<template>
  <div class="apoderado-upload-container">
    <h3 class="title">Ingreso Masivo de Apoderados</h3>

    <div class="upload-section">
      <label class="file-label">
        <span>Seleccionar archivo Excel (.xlsx, .xls)</span>
        <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" class="file-input" />
      </label>
    </div>

    <div v-if="excelData.length" class="table-container">
      <table class="apoderado-table">
        <thead>
          <tr>
            <th class="checkbox-column">
              <input type="checkbox" @change="toggleAllSelection" :checked="allSelected" />
            </th>
            <th v-for="(header, index) in tableHeaders" :key="index" class="header-cell">
              {{ header }}
            </th>
            <th class="status-column">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in excelData" :key="rowIndex" class="data-row">
            <td class="checkbox-column">
              <input type="checkbox" v-model="selectedRows" :value="row.data" />
            </td>
            <td v-for="(cell, cellIndex) in row.data" :key="cellIndex" class="data-cell">
              {{ cell }}
            </td>
            <td :class="getStatusClass(row.status)">
              {{ row.status || 'Pendiente' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="selectedRows.length" class="actions-section">
      <button class="action-button" @click="procesarApoderados" :disabled="isProcessing">
        {{ isProcessing ? 'Procesando...' : 'Procesar Apoderados' }}
      </button>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import UsuarioService from '@/services/UsuarioService';

export default {
  data() {
    return {
      excelData: [],
      tableHeaders: [],
      selectedRows: [],
      allSelected: false,
      isProcessing: false,
      usuarioId: 1, // ID del usuario que realiza el proceso
      colegios: {
        "NO APLICA": { id_colegio: 0, direccion_calle: "", direccion_numero: 0 },
        "MINEDUC DEMO": { id_colegio: 1, direccion_calle: "EJERCITO", direccion_numero: 557 },
        "COLEGIO ACONCAGUA": { id_colegio: 2, direccion_calle: "Camino Troncal Antiguo", direccion_numero: 1940 },
        "COLEGIO SAN NICOLÁS VILLA ALEMANA": { id_colegio: 3, direccion_calle: "Santa Sarah", direccion_numero: 1720 },
        "COLEGIO SAN NICOLÁS CANAL CHACAO": { id_colegio: 4, direccion_calle: "Los Lunes", direccion_numero: 373 },
        "COLEGIO SAN NICOLÁS EL OLIVAR": { id_colegio: 5, direccion_calle: "Tamarugal", direccion_numero: 575 }
      },
      regiones: [{ Id: 6, Glosa: 'Valparaíso' }],
      comunas: [
        { Id: 45, Glosa: 'Valparaíso' }, { Id: 46, Glosa: 'Casablanca' }, { Id: 47, Glosa: 'Concón' },
        { Id: 48, Glosa: 'Juan Fernández' }, { Id: 49, Glosa: 'Puchuncaví' }, { Id: 50, Glosa: 'Quilpué' },
        { Id: 51, Glosa: 'Quintero' }, { Id: 52, Glosa: 'Villa Alemana' }, { Id: 53, Glosa: 'Viña del Mar' },
        { Id: 54, Glosa: 'Isla de Pascua' }, { Id: 55, Glosa: 'Los Andes' }, { Id: 56, Glosa: 'Calle Larga' },
        { Id: 57, Glosa: 'Rinconada' }, { Id: 58, Glosa: 'San Esteban' }, { Id: 59, Glosa: 'La Ligua' },
        { Id: 60, Glosa: 'Cabildo' }, { Id: 61, Glosa: 'Papudo' }, { Id: 62, Glosa: 'Petorca' },
        { Id: 63, Glosa: 'Zapallar' }, { Id: 64, Glosa: 'Quillota' }, { Id: 65, Glosa: 'La Calera' },
        { Id: 66, Glosa: 'Hijuelas' }, { Id: 67, Glosa: 'La Cruz' }, { Id: 68, Glosa: 'Limache' },
        { Id: 69, Glosa: 'Nogales' }, { Id: 70, Glosa: 'Olmué' }, { Id: 71, Glosa: 'San Antonio' },
        { Id: 72, Glosa: 'Algarrobo' }, { Id: 73, Glosa: 'Cartagena' }, { Id: 74, Glosa: 'El Quisco' },
        { Id: 75, Glosa: 'El Tabo' }, { Id: 76, Glosa: 'Santo Domingo' }, { Id: 77, Glosa: 'San Felipe' },
        { Id: 78, Glosa: 'Catemu' }, { Id: 79, Glosa: 'Llay-Llay' }, { Id: 80, Glosa: 'Panquehue' },
        { Id: 81, Glosa: 'Putaendo' }, { Id: 82, Glosa: 'Santa María' }
      ]
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        this.tableHeaders = jsonData[0];
        this.excelData = jsonData.slice(1).map(row => ({
          data: row,
          status: ''
        }));
        this.selectedRows = [];
        this.allSelected = false;
      };
      reader.readAsArrayBuffer(file);
    },

    toggleAllSelection(event) {
      this.selectedRows = event.target.checked 
        ? this.excelData.map(row => row.data) 
        : [];
      this.allSelected = event.target.checked;
    },

    getIdComunaPorColegio(colegioGlosa) {
      const comunaPorColegio = {
        "NO APLICA": "Villa Alemana",
        "MINEDUC DEMO": "Villa Alemana",
        "COLEGIO ACONCAGUA": "Quilpué",
        "COLEGIO SAN NICOLÁS VILLA ALEMANA": "Villa Alemana",
        "COLEGIO SAN NICOLÁS CANAL CHACAO": "Quilpué",
        "COLEGIO SAN NICOLÁS EL OLIVAR": "Viña del Mar"
      };
      const comunaGlosa = comunaPorColegio[colegioGlosa] || "Villa Alemana";
      const comuna = this.comunas.find(c => c.Gosa === comunaGlosa);
      return comuna ? comuna.Id : 52;
    },

   async procesarApoderados() {
  if (this.isProcessing || !this.selectedRows.length) return;
  this.isProcessing = true;
  const errores = [];

  try {
    for (const rowData of this.selectedRows) {
      try {
        console.log('Procesando fila:', rowData);
        this.updateRowStatus(rowData, 'Procesando');

        const colegioGlosa = rowData[0] ? rowData[0].toString().toUpperCase() : '';
        console.log('Colegio glosa:', colegioGlosa);
        const colegio = this.colegios[colegioGlosa];
        if (!colegio) {
          throw new Error(`Colegio no reconocido: ${rowData[0]}`);
        }

        const idComuna = this.getIdComunaPorColegio(colegioGlosa);
        console.log('ID Comuna:', idComuna);

        // Payload corregido
        const payloadApoderado = {
          pass_: Array.from(new TextEncoder().encode("12345678")),
          PassphraseEnteredByUser: "hola test estudyoo 2021 ##",
          id_usuario: this.usuarioId,
          id_contrato: 0,
          email: rowData[13], // CORREO_APO
          nombre_usuario: `${rowData[12]}.${rowData[10]}`, // nombre.PATERNO_APO
          nombre: rowData[12], // nombre_apoderado
          apellido_paterno: rowData[10], // PATERNO_APO
          apellido_materno: rowData[11], // MATERNO_APO
          celular: "0",
          identificador_rut: rowData[9], // RUT_APO
          sexo: rowData[14] ? rowData[14].charAt(0) : 'F', // SEXO_APO
          direccion_calle: colegio.direccion_calle,
          direccion_numero: colegio.direccion_numero,
          id_colegio: colegio.id_colegio,
          id_region: this.regiones[0].Id,
          id_comuna: idComuna,
          cursos: [rowData[1]], // Curso del alumno
          curso_casa: rowData[2] ? rowData[2].toString().charAt(0) : '', // Curso casa del alumno
          rut_alumno: rowData[3] // RUT del alumno
        };

        console.log('Payload enviado:', payloadApoderado);

        if (!payloadApoderado.email || !payloadApoderado.nombre || !payloadApoderado.identificador_rut) {
          throw new Error("Faltan campos obligatorios (correo, nombre o RUT) del apoderado");
        }

        const response = await UsuarioService.crearApoderadoIndividual(payloadApoderado);
        console.log('Respuesta de la API:', response.data);

        if (response.data.Mensaje === "Apoderado procesado con éxito") {
          console.log('Éxito confirmado para fila:', rowData);
          this.updateRowStatus(rowData, 'Éxito');
        } else {
          throw new Error(response.data.Mensaje || "Error desconocido en la respuesta");
        }
      } catch (error) {
        const errorMsg = error.message || "Error al procesar el apoderado";
        console.error('Error en fila:', rowData, 'Mensaje:', errorMsg);
        errores.push([...rowData, errorMsg]);
        this.updateRowStatus(rowData, `Error: ${errorMsg}`);
      }
    }

    console.log('Errores acumulados:', errores);
    console.log('Filas procesadas con éxito:', this.selectedRows.length - errores.length);

    if (errores.length > 0) {
      this.generarExcelErrores(errores);
      alert(`Se procesaron ${this.selectedRows.length - errores.length} apoderados con éxito. ${errores.length} fallaron.`);
    } else {
      alert("Todos los apoderados seleccionados fueron procesados exitosamente.");
    }

    this.selectedRows = [];
    this.allSelected = false;
  } catch (error) {
    console.error("Error inesperado en el proceso:", error);
    alert("Error inesperado al procesar los apoderados.");
  } finally {
    this.isProcessing = false;
  }
},
    updateRowStatus(rowData, status) {
      this.excelData = this.excelData.map(row => {
        if (row.data === rowData) {
          return { ...row, status };
        }
        return row;
      });
    },

    generarExcelErrores(errores) {
      const headers = [...this.tableHeaders, "Error"];
      const data = [headers, ...errores];
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Errores_Apoderados.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    },

    getStatusClass(status) {
      if (!status) return 'status-pending';
      if (status === 'Éxito') return 'status-success';
      if (status === 'Procesando') return 'status-processing';
      if (status.startsWith('Error')) return 'status-error';
      return 'status-pending';
    }
  }
};
</script>

<style scoped>
.apoderado-upload-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title {
  font-size: 24px;
  margin-bottom: 20px;
}

.upload-section {
  margin-bottom: 20px;
}

.file-label {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.file-input {
  display: none;
}

.table-container {
  overflow-x: auto;
}

.apoderado-table {
  width: 100%;
  border-collapse: collapse;
}

.header-cell, .data-cell {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.checkbox-column {
  width: 50px;
  text-align: center;
}

.status-column {
  width: 150px;
  text-align: center;
}

.data-row:hover {
  background-color: #f5f5f5;
}

.actions-section {
  margin-top: 20px;
}

.action-button {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.action-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.status-success {
  color: #28a745;
}

.status-error {
  color: #dc3545;
}

.status-processing {
  color: #007bff;
}

.status-pending {
  color: #6c757d;
}
</style>